import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  suppliers: [],
  supplier: {},
  totalSuppliers: 0,
  reviews: [],
  totalReviews: 0
};

const getters = {};

const actions = {
  LOAD_SUPPLIER: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios
      .get("/suppliers/" + payload.supplierId)
      .then(response => {
        commit("SET_SUPPLIER", response.data.supplier);
      });
  },
  LOAD_SUPPLIERS: function({ commit, rootState }, payLoad) {
    let nameQuery =
      payLoad.name && payLoad.name !== " "
        ? "&name=" + payLoad.name.trim()
        : "";
    let activeQuery =
      payLoad.active === 1 || payLoad.active === 0
        ? "&active=" + payLoad.active
        : "";

    let approvedQuery =
      payLoad.approved === 1 || payLoad.approved === 0
        ? "&approved=" + payLoad.approved
        : "";

    let postcodeQuery =
      payLoad.postcode && payLoad.postcode !== " "
        ? "&postcode=" + payLoad.postcode.trim()
        : "";

    return Vue.prototype.$axios
      .get(
        "/suppliers?from=" +
          payLoad.from +
          "&limit=" +
          payLoad.to +
          nameQuery +
          activeQuery +
          approvedQuery +
          postcodeQuery
      )
      .then(response => {
        commit("SET_SUPPLIERS", response.data.suppliers);
        commit("SET_TOTAL_SUPPLIERS", response.data.meta.total);
        return response;
      });
  },
  UPDATE_SUPPLIER: function({ commit, rootState, dispatch }, payLoad) {
    return Vue.prototype.$axios
      .post("/suppliers/" + payLoad.id, payLoad, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {});
  },
  CREATE_SUPPLIER: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .post("suppliers", payload)
      .then(response => {});
  },
  DESTROY_SUPPLIER: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .delete("suppliers/" + payload)
      .then(response => {});
  },
  LOAD_REVIEWS: async function({ commit }, payload) {
    return await Vue.prototype.$axios
      .get("reviews", {
        params: payload
      })
      .then(res => {
        commit("SET_REVIEWS", res.data.reviews);
        commit("SET_TOTAL_REVIEWS", res.data.meta.total);
      });
  }
};

const mutations = {
  SET_SUPPLIERS: (state, suppliers) => {
    state.suppliers = suppliers;
  },
  SET_TOTAL_SUPPLIERS: (state, totalSuppliers) => {
    state.totalSuppliers = totalSuppliers;
  },
  SET_SUPPLIER: (state, supplier) => {
    state.supplier = supplier;
  },
  SET_REVIEWS: (state, payload) => {
    state.reviews = payload;
  },
  SET_TOTAL_REVIEWS: (state, payload) => {
    state.totalReviews = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
